import { Meteor } from 'meteor/meteor';
import rateLimit from '../../modules/rate-limit';
import * as app from './server/app-methods-server';

Meteor.methods({
  'app.getDevEnvironment'() {
    return app.getDevEnvironment();
  },
  'app.getVersion'() {
    return app.getAppVersion();
  },
  'app.getTierra2API'(authenticated) {
    return app.getTierra2API(authenticated);
  }
});

rateLimit({
  methods: ['app.getDevEnvironment', 'app.getVersion'],
  limit: 5,
  timeRange: 1000
});
